import { tripPlanningComponent } from './trip-planning.component';
import { TripPlanningService } from './trip-planning.service';

export const tripPlanning = angular
    .module('components.tripPlanning', [])
    .service('TripPlanningService', TripPlanningService)
    .component('tripPlanning', tripPlanningComponent)
    // .config(($stateProvider) => {
    //     'ngInject';

    //     $stateProvider
    //         .state('app.dashboard.TripPlanning', {
    //             url: '/trip-planning',
    //             breadcrumbName: 'Trip Planning',
    //             parentState: 'dashboard',
    //             component: 'tripPlanning',
    //             resolve: {
    //                 details(TripPlanningService) {
    //                     'ngInject';

    //                     return TripPlanningService.getTripPlanningDetails();
    //                 }
    //             }
    //         });
    // })
    .name;


// WEBPACK FOOTER //
// ./src/app/components/trip-planning/trip-planning.module.js